import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { Error, Success } from "../../../commons/Messages/Messages";
import axios from "axios";
import DeleteModal from "../../../commons/DeleteModal/DeleteModal";
import AddMeetings from "./AddMeeting";
import moment from "moment";
import GeneralTable from "../../../commons/GeneralTable";
import { useTranslation } from "react-i18next";
import PageToolbar from "../../../design-system/PageToolbar";
import { openExternal } from "../../../native/files";

const Meetings = () => {
  const { t } = useTranslation("dashboard");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [totalCount, setTotalCount] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(9);

  const getData = async () => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/meetings`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          setData(res.data);
          setTotalCount(res.data.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        Error(err.message);
      });
  };

  const deleteHandler = async id => {
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/meetings/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          getData();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        Error(err.message);
      });
  };

  const joinMeeting = async e => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/meetings/join`,
        {
          ss: ""
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          openExternal(res.data);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        Error(err.message);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      title: "#",
      dataIndex: "_id",
      mobile: "hidden",
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a._id.length - b._id.length
    },
    {
      title: t("ID"),
      dataIndex: "meetingID",
      sorter: (a, b) => a.meetingID.localeCompare(b.meetingID)
    },
    {
      title: t("Title"),
      dataIndex: "meetingName",
      mobile: "title",
      sorter: (a, b) => a.meetingName.localeCompare(b.meetingName)
    },
    {
      title: t("Created At"),
      dataIndex: "createdAt",
      render: text => moment(text).format("DD/MMM/YYYY HH:mm:ss")
    },
    {
      title: t("Action"),
      key: "action",
      dataIndex: "",
      render: (text, obj) => (
        <div className="d-flex flex-wrap gap-2 align-items-center justify-content-end">
          <Button type="primary" className="join-meeting-button-color" onClick={joinMeeting}>
            {t("Join Meeting")}
          </Button>
          <DeleteModal text="Meeting" onClick={() => deleteHandler(obj?._id)} />
        </div>
      ),
      sorter: (a, b) => a.length - b.length
    }
  ];

  return htmlContent ? (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  ) : (
    <>
      <PageToolbar actions={<AddMeetings updateParent={getData} />} />
      <GeneralTable
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        data={data}
        columns={columns}
        setPageNo={setPageNo}
        loading={loading}
      />
    </>
  );
};

export default Meetings;
